"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function toInt(value) {
  let fractional = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (typeof value === 'number') {
    return fractional ? value : Math.trunc(value);
  }
  if (typeof value !== 'string') {
    return null;
  }
  const casted = Number(value);
  if (isNaN(casted)) {
    return null;
  }
  return fractional ? casted : Math.trunc(casted);
}
exports.toInt = toInt;